// extracted by mini-css-extract-plugin
export default {"root":"c9GVf","retry":"cIBqx","icon":"URd_z","text":"OAjLU","title":"BmDqX"};